import React, { useState } from "react";
import AddressSearch from "./AddressSearch";
import CurrentLocationAlert from "./CurrentLocationAlert";

function SearchAlerts() {
  const [activeTab, setActiveTab] = useState("currentLocation");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
<div className="bg-gray-100 p-4 rounded-lg shadow-md min-h-screen h-auto">
      <h1 className="text-2xl font-bold mb-4">Search Alerts </h1>
      <div className="flex justify-between">
        <div
          className={`${
            activeTab === "currentLocation"
              ? "text-red-500 border-b-2 border-red-500 pb-2 transition-transform duration-300 ease-in-out transform translate-x-0"
              : "text-gray-800 hover:text-red-500 hover:border-red-500 hover:pb-2 transition-transform duration-300 ease-in-out transform translate-x-4"
          } w-1/2 text-center cursor-pointer`}
          onClick={() => handleTabChange("currentLocation")}
        >
           Current Location
        </div>













        <div
          className={`${
            activeTab === "byAddress"
              ? "text-red-500 border-b-2 border-red-500 pb-2 transition-transform duration-300 ease-in-out transform translate-x-0"
              : "text-gray-800 hover:text-red-500 hover:border-red-500 hover:pb-2 transition-transform duration-300 ease-in-out transform translate-x-4"
          } w-1/2 text-center cursor-pointer`}
          onClick={() => handleTabChange("byAddress")}
        >
           Address
        </div>
      </div>



      {activeTab === "currentLocation" ? (<>


      <CurrentLocationAlert />
        
        </>
      ) : (

        <>

        <AddressSearch/>
        
        </>
      )}
    </div>
  );
}

export default SearchAlerts;
